import { useEffect, useState,useContext, useRef } from "react"
import {DataContext} from '../../../context/DataContext'
import {petitions} from '../../../api/calls'
import { toast } from "sonner";
import {useForm} from 'react-hook-form'
import Swal from 'sweetalert2';

function Marca() {
  const {session, idEmpresa } = useContext(DataContext);
  const [marca, setMarca] = useState([])
  const [modeloMarca, setModeloMarca] = useState([])  

  const [estMarca, setEstMarca] = useState(false)
  const [estModelo, setEstModelo] = useState(false)

  const [searchMarca, setSearchMarca] = useState("");
  const [searchModelo, setSearchModelo] = useState("");

  const modalRef1 = useRef(null);
  const modalRef2 = useRef(null);

  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef1.current);
    modalInstance.hide();
  };

  const closeModalModelo = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
    modalInstance.hide();
  };
  
  const form1 = useForm();
  const form2 = useForm();

  const filtereMarca = marca.filter((obj) =>
    obj.descripcion.toLowerCase().includes(searchMarca.toLowerCase())
  );

  const filtereModelo = modeloMarca.filter((obj) =>
    obj.descripcion.toLowerCase().includes(searchModelo.toLowerCase())
  );

  useEffect(() => {
    const fetchMarca = async () => {
      const response = await petitions.getMarca(idEmpresa(), session().token);
      if (response.status === "success") {
        setMarca(response.data);
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMarca();
  }, [estMarca, session, idEmpresa]);

  useEffect(() => {
    const fetchModeloMarca = async () => {
      const response = await petitions.getModeloMarca(idEmpresa(), session().token);
      if (response.status === "success") {
        setModeloMarca(response.data);
      } else {
        const msg = typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchModeloMarca();
  }, [estModelo, session, idEmpresa]);
  
  //MARCA
  const sendMarca = form1.handleSubmit(async (data) => {
    const response = await petitions.insertMarca(idEmpresa(), session().token,data);
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        setEstMarca(!estMarca);
        toast.success("Marca registrada correctamente");
        form1.reset(); 
      }
      else{
        closeModal();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      closeModal();
      var msg = typeof response.code === "string" ? response.message : response.data; 
      toast.error(msg);
    }
  })

  const deleteMarca = (idMarca) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
    
    swalWithBootstrapButtons.fire({
      title: "Estas seguro/a?",
      text: "No podrás cancelar el proceso",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "No, cancelar",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
          const response = await petitions.deleteMarca(idEmpresa(), session().token, {idMarca});
          if (response.status === "success") {
            if (response.data) {
              setEstMarca(!estMarca)
              toast.success("Marca eliminada correctamente")   
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde");
            }
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
      }
    });
  }

  //MODELO MARCA
  const sendModelo = form2.handleSubmit(async (data) => {
    const response = await petitions.insertModeloMarca(idEmpresa(), session().token, data);
    if (response.status === "success") {
      if (response.data) {
        closeModalModelo();
        setEstModelo(!estModelo)
        toast.success("Modelo registrado correctamente")
        form2.reset(); 
      }
      else{
        closeModalModelo();
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      closeModalModelo();
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const deleteModeloMarca = (id) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
    
    swalWithBootstrapButtons.fire({
      title: "Estas seguro/a?",
      text: "No podrás cancelar el proceso",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "No, cancelar",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
          const response = await petitions.deleteModeloMarca(idEmpresa(), session().token, {id});
          if (response.status === "success") {
            if (response.data) {
              setEstModelo(!estModelo)
              toast.success("Modelo eliminado correctamente") 
            }
            else{
              toast.warning("Ocurrió un problema, inténtelo mas tarde")  
            }
          } else {
            var msg = typeof response.code === "string" ? response.message : response.data;
            toast.error(msg);
          }
      }
    });
  }

  return (
    <>
      <div className="row gy-3 mb-4 justify-content-between">
        <div className="col-md-9 col-auto">
          <h2 className="mb-2 text-body-emphasis">Marcas y modelos</h2>
          <h5 className="text-body-tertiary fw-semibold">
            Gestiona las marcas y modelos afiliados a tu empresa.
          </h5>
        </div>
      </div>
      <div className="mx-lg-n4 mt-3">
        <div className="row g-3">
        <div className="col-12 col-xl-6 col-xxl-7">
            <div className="card todo-list h-100 rounded-4">
              <div className="card-header border-bottom-0 pb-0">
                <div className="row justify-content-between align-items-center mb-4">
                  <div className="col-auto">
                    <h3 className="text-body-emphasis">Marca</h3>
                    <p className="mb-0 text-body-tertiary">
                      Marcas disponibles de la empresa
                    </p>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div className="col-auto w-100 w-md-auto">
                    <div className="row align-items-center g-0 justify-content-between">
                      <div className="col-12 col-sm-auto">
                        <div
                          className="search-box w-100 mb-2 mb-sm-0"
                          style={{ maxWidth: "30rem" }}
                        >
                            <input
                              className="form-control search-input search rounded-4"
                              type="search"
                              placeholder="Buscar marcas"
                              aria-label="Search"
                              onChange={(event) => {setSearchMarca(event.target.value)}}
                            />
                            <span className="fas fa-search search-box-icon"></span>
                        </div>
                      </div>
                      <div className="col-auto d-flex">
                      <p className="mb-0 ms-sm-3 fs-9 text-body-tertiary fw-bold">
                          <span className="fas fa-filter me-1 fw-extra-bold fs-10"></span>
                          {marca.length} marcas
                        </p>
                        <div
                          className={
                            "btn btn-link p-0 ms-3 fs-9 text-" +
                            (marca.length > 0 ? "primary" : "danger") +
                            " fw-bold"
                          }
                        >
                          <span className="fas fa-sort me-1 fw-extra-bold fs-10"></span>
                          Estado
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 scrollbar to-do-list-body">
                {filtereMarca &&
                  filtereMarca.map((m) => (
                    <div
                      className="d-flex hover-actions-trigger py-3 border-top"
                      key={m.idMarca}
                    >
                      <div className="row justify-content-between align-items-md-center btn-reveal-trigger border-translucent gx-0 flex-1">
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="mb-1 mb-md-0 d-flex align-items-center lh-1">
                            <label className="form-check-label mb-1 mb-md-0 mb-xl-1 mb-xxl-0 fs-8 me-2 line-clamp-1 text-body">
                              {m.idMarca}
                            </label>
                            <button className="badge badge-phoenix ms-auto fs-10 badge-phoenix-info" disabled={true} style={{display:"none"}}>
                              editar
                            </button>
                            <button className="badge badge-phoenix ms-auto ms-2 fs-10 badge-phoenix-danger rounded-4" onClick={() =>{deleteMarca(m.idMarca)}}>
                              eliminar
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="d-flex lh-1 align-items-center">
                            <div className="hover-md-hide hover-xl-show hover-xxl-hide">
                              <p className="text-body-tertiary fs-10 fw-bold mb-md-0 mb-0 ps-md-3 ps-xl-0 ps-xxl-3 border-start-md border-xl-0 border-start-xxl">
                                {m.descripcion}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer border-0">
                <a
                  className="fw-bold fs-9 mt-4"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAgregarMarca"
                >
                  <span className="fas fa-plus me-1"></span>Agregar nueva marca
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6 col-xxl-7">
            <div className="card todo-list h-100 rounded-4">
              <div className="card-header border-bottom-0 pb-0">
                <div className="row justify-content-between align-items-center mb-4">
                  <div className="col-auto">
                    <h3 className="text-body-emphasis">Modelo</h3>
                    <p className="mb-0 text-body-tertiary">
                      Modelos disponibles de la empresa
                    </p>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div className="col-auto w-100 w-md-auto">
                    <div className="row align-items-center g-0 justify-content-between">
                      <div className="col-12 col-sm-auto">
                        <div
                          className="search-box w-100 mb-2 mb-sm-0"
                          style={{ maxWidth: "30rem" }}
                        >
                            <input
                              className="form-control search-input search rounded-4"
                              type="search"
                              placeholder="Buscar modelos"
                              aria-label="Search"
                              onChange={(event) => {setSearchModelo(event.target.value)}}
                            />
                            <span className="fas fa-search search-box-icon"></span>
                        </div>
                      </div>
                      <div className="col-auto d-flex">
                      <p className="mb-0 ms-sm-3 fs-9 text-body-tertiary fw-bold">
                          <span className="fas fa-filter me-1 fw-extra-bold fs-10"></span>
                          {modeloMarca.length} modelos
                        </p>
                        <div
                          className={
                            "btn btn-link p-0 ms-3 fs-9 text-" +
                            (modeloMarca.length > 0 ? "primary" : "danger") +
                            " fw-bold"
                          }
                        >
                          <span className="fas fa-sort me-1 fw-extra-bold fs-10"></span>
                          Estado
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 scrollbar to-do-list-body">
                {filtereModelo &&
                  filtereModelo.map((m) => (
                    <div
                      className="d-flex hover-actions-trigger py-3 border-top"
                      key={m.id}
                    >
                      <div className="row justify-content-between align-items-md-center btn-reveal-trigger border-translucent gx-0 flex-1">
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="mb-1 mb-md-0 d-flex align-items-center lh-1">
                            <label className="form-check-label mb-1 mb-md-0 mb-xl-1 mb-xxl-0 fs-8 me-2 line-clamp-1 text-body">
                              {m.id}
                            </label>
                            <button className="badge badge-phoenix ms-auto fs-10 badge-phoenix-info" disabled={true} style={{display:"none"}}>
                              editar
                            </button>
                            <button className="badge badge-phoenix ms-auto ms-2 fs-10 badge-phoenix-danger rounded-4" onClick={() =>{deleteModeloMarca(m.id)}}>
                              eliminar
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="d-flex lh-1 align-items-center">
                            <div className="hover-md-hide hover-xl-show hover-xxl-hide">
                              <p className="text-body-tertiary fs-10 fw-bold mb-md-0 mb-0 ps-md-3 ps-xl-0 ps-xxl-3 border-start-md border-xl-0 border-start-xxl">
                                {m.descripcion}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer border-0">
                <a
                  className="fw-bold fs-9 mt-4"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAgregarModelo"
                >
                  <span className="fas fa-plus me-1"></span>Agregar nuevo modelo
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODALS */}
      <div
        className="modal fade"
        id="modalAgregarMarca"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Marca
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendMarca}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Código de marca</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form1.register("idMarca",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    },
                    minLength: {
                      value: 3,
                      message: "El código debe ser de 3 digitos",
                    },
                    maxLength: {
                      value: 3,
                      message: "El código debe ser de 3 digitos",
                    },
                  })}/>
                  { form1.formState.errors?.idMarca && <code>{form1.formState.errors.idMarca.message}</code> } 
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Descripción</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form1.register("descripcion",{
                  })}/>
                  { form1.formState.errors?.descripcion && <code>{form1.formState.errors.descripcion.message}</code> } 
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAgregarModelo"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Modelo
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendModelo}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Código de modelo</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form2.register("id",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    },
                  })}/>
                  { form2.formState.errors?.id && <code>{form2.formState.errors.id.message}</code> } 
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Descripción</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form2.register("descripcion",{
                  })}/>
                  { form2.formState.errors?.descripcion && <code>{form2.formState.errors.descripcion.message}</code> } 
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Marca</label>
                  <select className="form-select rounded-4" {...form2.register("idMarca",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}>
                    {marca.map(option => (
                      <option key={option.idMarca} value={option.idMarca}>
                        {option.idMarca}{" - "}{option.descripcion}
                      </option>
                    ))}
                  </select>
                  { form2.formState.errors?.idMarca && <code>{form2.formState.errors.idMarca.message}</code> } 
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4"type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Marca

